import React from "react";
import { Link } from "react-router-dom";
import { Phone, Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="border-t border-white/10 bg-black/60 mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src="https://customer-assets.emergentagent.com/job_frame-racer-depot/artifacts/ewmv2tas_image.png"
            alt="Apex Designs"
            style={{ mixBlendMode: "screen" }}
            className="h-12 w-auto"
          />
          <p className="text-zinc-400 mt-4 max-w-md text-sm leading-relaxed">
            Hand-curated brick-built F1 car frames, sim-racing gear and
            3D-printed motorsport models. Built in India for collectors and
            enthusiasts who breathe motorsport.
          </p>
          <p className="af-mono text-[11px] text-zinc-600 mt-6 uppercase tracking-[0.2em]">
            // Your vision, built. Engineered for the shelf.
          </p>
        </div>

        <div>
          <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-4">
            // Explore
          </p>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li><Link to="/shop" className="hover:text-white" data-testid="footer-link-shop">Shop frames</Link></li>
            <li><Link to="/coming-soon" className="hover:text-white" data-testid="footer-link-coming-soon">Coming soon</Link></li>
            <li><Link to="/custom-request" className="hover:text-white" data-testid="footer-link-custom">Custom build</Link></li>
            <li><Link to="/track" className="hover:text-white" data-testid="footer-link-track">Track order</Link></li>
            <li><Link to="/orders" className="hover:text-white" data-testid="footer-link-orders">My orders</Link></li>
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About</Link></li>
          </ul>
        </div>

        <div>
          <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-4">
            // Contact
          </p>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li>
              <a
                href="tel:+919820078697"
                className="flex items-center gap-2 hover:text-white"
                data-testid="footer-phone-link"
              >
                <Phone size={14} strokeWidth={1.5} />
                <span className="af-mono">+91 98200 78697</span>
              </a>
            </li>
            <li className="flex items-center gap-2 text-zinc-400">
              <Mail size={14} strokeWidth={1.5} />
              contact@apexdzns.com
            </li>
            <li className="flex items-center gap-2 text-zinc-400">
              <Instagram size={14} strokeWidth={1.5} />
              @apexdzns
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © {new Date().getFullYear()} Apex Designs. All rights reserved.
          </p>
          <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Mumbai // India
          </p>
        </div>
      </div>
    </footer>
  );
}
